import { render, staticRenderFns } from "./FichaHeader.vue?vue&type=template&id=1db28b6a&"
import script from "./FichaHeader.vue?vue&type=script&lang=js&"
export * from "./FichaHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports